import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import taskTypeReducer from './slice/taskTypeSlice';
import userReducer from './slice/userSlice';
import mapSlice from './slice/mapSlice';
import rolReducer from './slice/rolSlice';
import taskReducer from './slice/taskSlice';
import mapLayersSlice from './slice/mapLayersSlice';
import mapAOISlice from './slice/mapAOISlice';
import adjuntosSlice from './slice/adjuntosSlice';
import reportsSlice from './slice/reportsSlice';
import gestorCapasSlice from './slice/gestorCapasSlice';
import importadorSlice from './slice/importadorXlsxSlice';

export const store = configureStore({
  reducer: {
    taskType: taskTypeReducer,
    user: userReducer,
    map: mapSlice,
    mapLayers: mapLayersSlice,
    rol: rolReducer,
    task: taskReducer,
    mapAOI: mapAOISlice,
    adjuntos: adjuntosSlice,
    reports: reportsSlice,
    gestorCapas: gestorCapasSlice,
    importador: importadorSlice

  },
  //Se agrega esta linea de codigo ya que generaba un warning en la herramienta de devtools(chrome)
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(
    {serializableCheck: false}
  ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
